/**
 * App.jsx — MFE Shell
 *
 * Shell owns: UI chrome, theme orchestration, and MFE coordination.
 * ThemeProvider sits first so data-theme is set on <html> before
 * any MFE renders — prevents a flash of unstyled content.
 */
import { useMFEBus }        from './mfe/hooks'
import MFEBus               from './mfe/MFEBus'
import { createMFE }        from './mfe/MFERegistry'

import {
  GrainOverlay,
  ScrollProgress,
  CursorGlow,
  MagneticCursor,
  BgCanvas,
  NavBar,
  TickerMarquee,
  BackToTop,
  MFEDevPanel,
  ThemeProvider,
} from './shell'

import { HeroSection }      from './sections/hero'
import { PipelineSection }  from './sections/pipeline'
import { AboutSection }     from './sections/about'
import { SkillsSection }    from './sections/skills'
import { CareerSection }    from './sections/career'
import { EducationSection } from './sections/education'
import { ProjectsSection }  from './sections/projects'
import { ContactSection }   from './sections/contact'

const MFE_Hero      = createMFE({ name: 'mfe-hero',      version: '3.2.1', team: 'Experience' }, HeroSection)
const MFE_Pipeline  = createMFE({ name: 'mfe-pipeline',  version: '1.2.0', team: 'DevOps'     }, PipelineSection)
const MFE_About     = createMFE({ name: 'mfe-about',     version: '1.0.4', team: 'Content'    }, AboutSection)
const MFE_Skills    = createMFE({ name: 'mfe-skills',    version: '1.3.0', team: 'Content'    }, SkillsSection)
const MFE_Career    = createMFE({ name: 'mfe-career',    version: '2.0.0', team: 'Content'    }, CareerSection)
const MFE_Education = createMFE({ name: 'mfe-education', version: '1.0.2', team: 'Content'    }, EducationSection)
const MFE_Projects  = createMFE({ name: 'mfe-projects',  version: '3.0.0', team: 'Portfolio'  }, ProjectsSection)
const MFE_Contact   = createMFE({ name: 'mfe-contact',   version: '1.5.2', team: 'Platform'   }, ContactSection)

export default function App() {
  useMFEBus('contact:sent', () => MFEBus.emit('mfe:note', { msg: 'Contact form submitted 🚀' }), [])
  useMFEBus('mfe:error',    p  => console.warn('[Shell] MFE error in', p.name, '–', p.message),  [])

  return (<>
    {/* ThemeProvider first — sets data-theme before any paint */}
    <ThemeProvider/>

    <GrainOverlay/>
    <ScrollProgress/>
    <MagneticCursor/>
    <CursorGlow/>
    <BgCanvas/>
    <NavBar/>

    <MFE_Hero/>
    <TickerMarquee/>
    <MFE_Pipeline/>
    <div className="sec-div"/>
    <MFE_About/>
    <div className="sec-div"/>
    <MFE_Skills/>
    <div className="sec-div"/>
    <MFE_Career/>
    <div className="sec-div"/>
    <MFE_Education/>
    <div className="sec-div"/>
    <MFE_Projects/>
    <div className="sec-div"/>
    <MFE_Contact/>

    <footer>
      <p>© {new Date().getFullYear()} Devamkumar Patel · React Micro Frontends + Three.js</p>
    </footer>

    <BackToTop/>
    <MFEDevPanel/>
  </>)
}
